import { fetchAccessToken, getAccessToken, isValid, setAccessToken } from '../components/accesstoken';
import { config } from '../config';
import { trackError } from '../analytics/track';

const apiBaseUrl = `${config.VITE_GRAPHQL_URL}/api`;

export const apiFetch = async (path: string, options?: RequestInit) => {
  let accessToken = getAccessToken();
  if (!(await isValid(accessToken))) {
    ({ accessToken } = await fetchAccessToken());
    if (!accessToken.length || accessToken.trim() === '') throw new Error('Failed to obtain valid access token');
    setAccessToken(accessToken);
  }
  const headers = {
    'Content-Type': 'application/json',
    ...(options?.headers || {}),
    Authorization: `bearer ${accessToken}`,
  };
  try {
    const response = await fetch(`${apiBaseUrl}${path}`, { ...options, headers });
    if (!response.ok) trackError('api', response.status);
    return response;
  } catch (error) {
    trackError('api');
    throw error;
  }
};
